import type { GeometryTool } from './interaction';

type IconName = GeometryTool
  | 'grid'
  | 'snap-point'
  | 'ortho'
  | 'fit-all'
  | 'fit-selection'
  | 'undo'
  | 'redo'
  | 'delete-vertex'
  | 'delete-selected';

export function GeometryToolIcon({ name }: { name: IconName }) {
  const common = {
    viewBox: '0 0 24 24',
    width: 20,
    height: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  };

  if (name === 'select') return <svg {...common}><path d="M5 3l12 8-5.3 1.2L15 18l-2.7 1.5-3.1-5.7L5 17z" /></svg>;
  if (name === 'pan') return <svg {...common}><path d="M8 11V6a1.5 1.5 0 013 0v4-5a1.5 1.5 0 013 0v5-3a1.5 1.5 0 013 0v5-2a1.5 1.5 0 013 0v5c0 4-2.5 6-6 6h-1c-2 0-3.4-.8-4.5-2.4L5 13.5A1.7 1.7 0 018 11z" /></svg>;
  if (name === 'draw-roof-rectangle') return <svg {...common}><rect x="4" y="5" width="16" height="14" rx="1" /><circle cx="4" cy="5" r="1.2" /><circle cx="20" cy="19" r="1.2" /></svg>;
  if (name === 'draw-roof-polygon') return <svg {...common}><path d="M5 6l7-3 7 5-2 11H7L3 12z" /><circle cx="5" cy="6" r="1.2" /><circle cx="19" cy="8" r="1.2" /><circle cx="7" cy="19" r="1.2" /></svg>;
  if (name === 'draw-opening-rectangle') return <svg {...common}><rect x="3" y="4" width="18" height="16" rx="1" /><rect x="8" y="8" width="8" height="8" rx=".5" /></svg>;
  if (name === 'draw-opening-polygon') return <svg {...common}><path d="M3 4h18v16H3z" /><path d="M8 9l4-2 5 3-2 6H9l-2-4z" /></svg>;
  if (name === 'insert-vertex') return <svg {...common}><path d="M3 16l7-7 11 7" /><circle cx="10" cy="9" r="2.2" /><path d="M10 3v4M8 5h4" /></svg>;
  if (name === 'move-opening') return <svg {...common}><rect x="7" y="7" width="10" height="10" /><path d="M12 2v4M12 18v4M2 12h4M18 12h4M10 4l2-2 2 2M10 20l2 2 2-2M4 10l-2 2 2 2M20 10l2 2-2 2" /></svg>;
  if (name === 'grid') return <svg {...common}><path d="M4 4h16v16H4zM9.3 4v16M14.7 4v16M4 9.3h16M4 14.7h16" /></svg>;
  if (name === 'snap-point') return <svg {...common}><circle cx="12" cy="12" r="7" /><circle cx="12" cy="12" r="2" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></svg>;
  if (name === 'ortho') return <svg {...common}><path d="M5 4v15h15" /><path d="M8 16h3v3" /></svg>;
  if (name === 'fit-all') return <svg {...common}><path d="M9 4H4v5M15 4h5v5M9 20H4v-5M15 20h5v-5" /><rect x="8" y="8" width="8" height="8" /></svg>;
  if (name === 'fit-selection') return <svg {...common}><path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5" /><circle cx="12" cy="12" r="3" /></svg>;
  if (name === 'undo') return <svg {...common}><path d="M9 7H4v-5M4 7l4-4" /><path d="M5 7h8a6 6 0 010 12H9" /></svg>;
  if (name === 'redo') return <svg {...common}><path d="M15 7h5v-5M20 7l-4-4" /><path d="M19 7h-8a6 6 0 000 12h4" /></svg>;
  if (name === 'delete-vertex') return <svg {...common}><path d="M4 16l6-6 10 6" /><circle cx="10" cy="10" r="2" /><path d="M7 4h6" /></svg>;
  if (name === 'delete-selected') return <svg {...common}><path d="M5 7h14M9 7V4h6v3M8 10v8M12 10v8M16 10v8M7 7l1 14h8l1-14" /></svg>;
  return null;
}
